import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { projectsData } from '../data';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';

const ProjectsDetails = () => {
   // console.log(projectsData)
   const {id}=useParams();

   const [items, setItems] = useState([]);
    useEffect(() =>{
        if(id){
          const item =projectsData.filter(data=>data.id===id);
          setItems(item);
        }
        else{
            return;
        }
    }
        
    ,[id]);
    console.log(items[0]?.name);
   
    
    return (
        <div className=' bg-gradient-to-r from-blue-500 to-transparent grid h-screen place-content-center'>
            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 place-items-center'>
               
                <PhotoProvider>
                    
                    <PhotoView src={items[0]?.imag1}>
                        <img className='w-[600px] h-[600px]' src={items[0]?.imag1} alt="Shoes" />

                    </PhotoView>
                    
                </PhotoProvider>
                <PhotoProvider>
                    
                    <PhotoView src={items[0]?.imag2}>
                        <img className='w-[600px] h-[600px]' src={items[0]?.imag2} alt="Shoes" />

                    </PhotoView>
                    
                </PhotoProvider>
                <PhotoProvider>
                    
                    <PhotoView src={items[0]?.imag3}>
                        <img className='w-[600px] h-[600px]' src={items[0]?.imag3} alt="Shoes" />

                    </PhotoView>
                    
                </PhotoProvider>
                
            </div>
            <div>
                <h1 className='text-black text-2xl font-serif text-center my-4 border border-black py-5'>{items[0]?.details} </h1>
                <div className='flex flex-col w-56  mx-auto'>
                    <a className='btn btn-primary bg-slate-400 my-2' href={items[0]?.link}>Live Link</a>
                    <a className='btn btn-primary bg-slate-400 my-2' href={items[0]?.client}>GitHub (Client)</a>
                    {
                        items[0]?.server ==='' ?
                        ''
                        :
                            <a className='btn btn-primary bg-slate-400 my-2' href={items[0]?.server}>Github(Server)</a> 
                    }
                </div>
            </div>
      </div>
      
       
    );
};

export default ProjectsDetails;